import { Avatar, AvatarGroup as AvatarGroupMaterial } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';

const AVATAR_FAKE = [
    'https://photo-cms-anninhthudo.zadn.vn/w600/Uploaded/2021/170/2020_08_08/pulisic.jpg',
    'https://danongonline.com.vn/wp-content/uploads/2019/12/gai-tay-xinh-7-696x696.jpg',
    'https://yfbca.org/wp-content/uploads/2019/09/cau-thu-dep-trai-1-min.jpg',
    'https://toplist.vn/images/800px/david-beckham-675100.jpg',
    'https://cdn.bongdaplus.vn/Assets/Media/2017/06/01/25/2.jpg',
    'https://cdn.24h.com.vn/upload/4-2020/images/2020-11-23/Chelsea-thang-hoa-Huyen-thoai-MU-chi-ra-chia-khoa-giup-The-Blues-vo-dich-Ngoai-hang-Anh-silva-1606127309-728-width660height429.jpg',
    'https://static.bongda24h.vn/medias/original/2019/9/21/Thong-ke-Premier-League-2010---2019-Fellaini-da-xau-nhat-hinh-anh.JPG',
    'https://media.bongda.com.vn/files/thach.pham/2019/01/11/1-0808.jpg'
];

interface IProps {
    avatars?: string[]; // url
    max?: number;
}
export const AvatarGroup: FC<IProps> = ({ avatars = AVATAR_FAKE, max = 5 }) => {
    return (
        <AvatarGroupMaterial
            sx={{
                justifyContent: 'start',
                '.MuiAvatarGroup-avatar ': {
                    width: 24,
                    height: 24,
                    fontSize: 10,
                    color: Colors.mediumPurpleViolet,
                    background: Colors.magnoliaWhite
                }
            }}
            total={avatars.length}
            max={max}
        >
            {[
                avatars.map((avatar, index) => {
                    return <Avatar key={index} alt="Remy Sharp" src={avatar} />;
                })
            ]}
        </AvatarGroupMaterial>
    );
};
